var moduleMap = {
	"./filePickerPageBootstrap": () => {
		return Promise.all([__webpack_require__.e(5205), __webpack_require__.e(3129), __webpack_require__.e(9141), __webpack_require__.e(3680), __webpack_require__.e(4914), __webpack_require__.e(4294), __webpack_require__.e(7636), __webpack_require__.e(4145), __webpack_require__.e(1023), __webpack_require__.e(2339), __webpack_require__.e(3568), __webpack_require__.e(5613), __webpack_require__.e(9610), __webpack_require__.e(9111), __webpack_require__.e(3875), __webpack_require__.e(9890), __webpack_require__.e(6398), __webpack_require__.e(4050), __webpack_require__.e(6035), __webpack_require__.e(9917), __webpack_require__.e(9870)]).then(() => (() => ((__webpack_require__(9939)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});